import { App, Image } from '@tribeplatform/gql-client/types'
import { InitialsAvatarPlaceholder } from '@tribeplatform/react-components/common/components/member'
import { Avatar, type AvatarSize } from '@tribeplatform/react-ui-kit/Avatar'

export interface AppIconProps {
  app: App
  size: AvatarSize
  className?: string
}

export const AppIcon = ({ app, size, className }: AppIconProps) => {
  return (
    <Avatar
      size={size}
      rounded="base"
      name={app?.name}
      src={(app?.image as Image)?.url}
      className={className}
      fallback={InitialsAvatarPlaceholder}
    />
  )
}
